var installedModules = {};
var moduleToHandlerMapping = {
	42604: {
		getter: () => (__webpack_require__.e(2791).then(() => (() => (__webpack_require__(72791))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.2.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	28392: {
		getter: () => (__webpack_require__.e(4164).then(() => (() => (__webpack_require__(54164))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.2.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	51539: {
		getter: () => (Promise.all([__webpack_require__.e(2556), __webpack_require__.e(667)]).then(() => (() => (__webpack_require__(20667))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "*",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@mui/system",
	},
	67182: {
		getter: () => (__webpack_require__.e(6276).then(() => (() => (__webpack_require__(46276))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^6.3.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-router-dom",
	},
	94427: {
		getter: () => (Promise.all([__webpack_require__.e(5148), __webpack_require__.e(2556), __webpack_require__.e(8460)]).then(() => (() => (__webpack_require__(48460))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "*",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@mui/material",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"2604": [
		42604
	],
	"6048": [
		67182,
		94427
	],
	"6979": [
		28392,
		51539
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}